/**
 * defa.collections.UnitTests
 * A collection of UnitTest models.
 * @version 1.2.0
 */
import UnitTest from 'scripts/defa/unit-tests/model-unit-test';

const UnitTests = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: UnitTest,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default UnitTests;